import { EspacioBlanco, required, type } from "@/commons/utils/Rules";
import 'element-ui/lib/theme-chalk/display.css';
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument";
export default {
  name: 'PzPersonForm1Oca',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzIdentityDocument: PzIdentityDocument
  },
  mixins: [PzBaseForm1],
  data: function data() {
    return {
      reference: 'formulario1',
      marital_status: [],
      formulario1: {
        nombres: '',
        apellidos: '',
        telefono: '',
        fecha_nacimiento: '',
        cuota_maxima: '',
        email: '',
        identity: {
          document: 1
        },
        clearing: null
      },
      rules_formulario1: {
        nombres: [required(''), EspacioBlanco()],
        apellidos: [required(''), EspacioBlanco()],
        'identity.document': [required('')],
        'identity.number': [required('')],
        telefono: [required('')],
        fecha_nacimiento: [required('')],
        email: [type({
          field: '',
          type: 'email'
        })]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return Date.now() < time.getTime();
        }
      }
    };
  },
  created: function created() {},
  methods: {}
};